import { TextNode } from "lexical";
import type { SerializedEditorState } from "lexical";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { ListNode, ListItemNode } from "@lexical/list";
import { UNORDERED_LIST, ORDERED_LIST } from "@lexical/markdown";

// Shared Lexical config for the notes editor and the read-only viewer so both
// render with identical formatting.
// These values are css class names that control the styling for each element
export const notesTheme = {
  paragraph: "editor-paragraph",
  heading: {
    h1: "editor-heading-h1",
    h2: "editor-heading-h2",
    h3: "editor-heading-h3",
  },
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
    underline: "editor-text-underline",
    strikethrough: "editor-text-strikethrough",
  },
  list: {
    ul: "editor-list-ul",
    ol: "editor-list-ol",
    listitem: "editor-listitem",
  },
};

export const NOTE_NODES = [TextNode, HeadingNode, QuoteNode, ListNode, ListItemNode];

// Markdown shortcuts: typing "- " or "* " starts a bullet list, "1. " starts an ordered list.
export const LIST_TRANSFORMERS = [UNORDERED_LIST, ORDERED_LIST];

export function notesOnError(error: Error) {
  console.error(error);
}

export const parseNoteContent = (content: string | undefined): SerializedEditorState | null => {
  if (!content) return null;
  try {
    return JSON.parse(content) as SerializedEditorState;
  } catch (error) {
    notesOnError(error as Error);
    return null;
  }
};
